<template>
  <TableRole />
</template>
<script>
import TableRole from "./components/tableRole";
export default {
  components: {
    TableRole,
  },
  methods: {},
  created() {},
};
</script>
<style></style>
